<template>
  <transition name="fade" appear>
    <div
      v-show="modal"
      class="c-popup"
    >
      <div class="c-popup__bg"></div>
      <div class="c-popup__inner">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
  import { computed, onMounted } from "vue";

  const props = withDefaults(
    defineProps<{
      isOpen?: boolean
    }>(),
    {
      isOpen: false
    }
  )

  const modal = computed(() => {
    const body = document.body
    if (props.isOpen) {
      fixBackground(body)
    } else {
      unfixBackground(body)
    }
    return props.isOpen
  })

  onMounted(() => {
    window.addEventListener("scroll", () => {
      document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`)
    })
  })

  function fixBackground(body) {
    // モーダルが開いたとき背景をスクロールした位置で固定にしてスクロールできないようする。
    const scrollY = document.documentElement.style.getPropertyValue("--scroll-y")
    body.style.position = "fixed"
    body.style.top = `-${scrollY}`
  }

  function unfixBackground(body) {
    const scrollY = body.style.top
    body.style.position = ""
    body.style.top = ""
    window.scrollTo(0, parseInt(scrollY || "0") * -1)
    // モーダル chain 時にスクロール位置が戻らないようにセット
    document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`)
  }
</script>

<style lang="scss" scoped>
.c-popup {
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .7s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
